module.exports = __webpack_public_path__ + "img/icon_map_5_yj_hg_c.2aeac8f5.png";